import { render } from "./Ordinary.vue?vue&type=template&id=9db11112&scoped=true"
import script from "./Ordinary.vue?vue&type=script&lang=js"
export * from "./Ordinary.vue?vue&type=script&lang=js"

import "./Ordinary.vue?vue&type=style&index=0&id=9db11112&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db11112"]])

export default __exports__